import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  checkboxContainer: {
    marginTop: theme.spacing(1),
  },
  checkbox: {
    alignSelf: "center",
    marginRight: ".5rem",
    color: "#C2C2C2",
  },
  checkboxLabel: {
    justifyContent: "space-betwen",
    height: "40px",
    alignItems: "center",
  },
  container: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
    justifyContent: "space-between",
  },
}));

export default useStyles;
